import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Invoice } from 'components';

import './InvoicesList.scss';

export const blockName = 'invoices-list';

const InvoicesList = props => {
  const moonshotInvoiceFlag = useSelector(
    state => state.invoices.moonshotInvoiceFlag
  );

  return (
    <div id={blockName} className={blockName} data-testid={blockName}>
      {props.invoices.map((invoice, index) => (
        <Invoice
          key={index}
          {...invoice}
          startGetInvoicePDF={props.startGetInvoicePDF}
          invoiceFileAvailable={
            moonshotInvoiceFlag ? invoice.invoiceFileAvailable : true
          }
        />
      ))}
    </div>
  );
};

InvoicesList.propTypes = {
  invoices: PropTypes.array.isRequired,
  startGetInvoicePDF: PropTypes.func.isRequired,
};

export default InvoicesList;
